import CityPageTemplate from './CityPageTemplate';

export default function OrlandoPage() {
  return (
    <CityPageTemplate
      city="Orlando"
      county="Orange"
      slug="orlando"
      zipCodes={['32801', '32803', '32808']}
      neighborhoods={['Downtown Orlando', 'Thornton Park', 'College Park', 'Mills 50', 'Dr. Phillips', 'Baldwin Park', 'Conway']}
      localContext="Orlando is the heart of Central Florida — from the high-rises of Downtown to the tree-lined streets of College Park and Thornton Park, we bring the boom to every room in the City Beautiful."
      metaDescription="Professional residential and commercial cleaning services in Orlando, FL. Serving ZIP codes 32801, 32803 & 32808. We Bring the Boom to Every Room. Call SOTSVC today!"
    />
  );
}
